import { useCallback, useEffect, useState } from "react";
import { Autocomplete, Chip } from "@mui/material";

import {
    Avatar,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    Grid,
    IconButton,
    Stack,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";

import { Delete, Edit } from "@mui/icons-material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useNavigate } from "react-router-dom";
import { getAllBrand } from "../../apis/Brand";
import { Create, UpdatePlayoff, getPlayoffBuckets } from "../../apis/Playoff";
import { getTags } from "../../apis/Tags";
import { usePlayoffContext } from "../../context/PlayoffContext";
import { AestheticInput } from "../../pages/Playoff/AestheticInput";
import { getCurrentUser } from "../../store/authentication/service";
import ControlledAutocomplete from "../Form/ControlledAutocomplete";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { Group } from "./Group";
import { ImageCropper } from "../CommonFunctions/ImageCropper";
import { showToast } from "../../utils/toast";
import { FullHeightLoader } from "../Loader/FullHeightLoader";
import FormWrapper from "../Form/FormWrapper";
export const PlayoffForm = ({ playoff = null }) => {
    const {
        isGrouped,
        setIsGrouped,
        groups,
        products,
        handleAddGroup,
        setGroupOpen,
        setGroups,
        prize,
        handleAddPrize,
        setPlayoff,
        allowedToCart,
        setAllowedToCart,
        loading,
        setLoading,
    } = usePlayoffContext();

    const navigate = useNavigate();
    const form = useForm();
    const {
        register,
        handleSubmit,
        setValue,
        control,
        unregister,
        watch,
        reset,
        formState: { errors },
    } = form;

    const [listCategories, setListCategories] = useState([]);
    const [user, setUser] = useState(null);
    const [image, setImage] = useState(null);
    const [open, setOpen] = useState(false);
    const [filename, setFilename] = useState("");
    const [deleteGroup, setDeleteGroup] = useState(null);
    const [groupOpen, setGroupOpenDialog] = useState(false);
    const [buckets, setBuckets] = useState([]);
    const [openBucketDialog, setOpenBucketDialog] = useState(false);
    const [selectedBuckets, setSelectedBuckets] = useState([]);
    // const [buckets, setBuckets] = useState([]);

    const handleOpenBucketDialog = async () => {
        let bucketList = buckets;

        if (!bucketList.length) {
            bucketList = await fetchBuckets();
        }

        const selectedIds = watch("buckets") || [];

        setSelectedBuckets(
            bucketList.filter((bucket) =>
                selectedIds.includes(bucket.id)
            )
        );

        setOpenBucketDialog(true);
    };

    const handleCloseBucketDialog = () => {
        const selectedIds = watch("buckets") || [];

        setSelectedBuckets(
            buckets.filter((bucket) => selectedIds.includes(bucket.id))
        );

        setOpenBucketDialog(false);
    };
    const fetchBuckets = useCallback(async () => {
        try {
            const response = await getPlayoffBuckets(1000, 1);
            setBuckets(response.results);
            return response.results;
        } catch (error) {
            console.error(error);
            return [];
        }
    }, []);
    useEffect(() => {
        if (!openBucketDialog) {return;}

        fetchBuckets();
    }, [fetchBuckets, openBucketDialog]);

    useEffect(() => {
        if (playoff) {

            console.log(playoff);
            console.log("bucket///////////", playoff.buckets);
            setAllowedToCart(playoff.allowed_to_cart);
            setPlayoff(playoff);
            setImage(playoff.image.file || "");
            reset({
                title: playoff.title || "",
                description: playoff.description || "",
                alias: playoff.alias || "",
                small_description: playoff.small_description || "",
                play_off_end_date_time:
                    moment(playoff.play_off_end_date_time) || "",
                play_off_start_date_time:
                    moment(playoff.play_off_start_date_time) || "",

                aesthetic: playoff.aesthetic || null,
                is_playoff: playoff.is_playoff || false,
                price_limit: playoff.price_limit || "",
                brand: playoff.brand.length ? playoff.brand[0] : "",
                pin_to_top: playoff.pin_to_top || false,
                active: !playoff.active || false,
                buckets: playoff.buckets?.map((bucket) => bucket.id) || [],
            });
            setSelectedBuckets(playoff.buckets || []);
        }
    }, [playoff, reset, setAllowedToCart, setPlayoff]);

    useEffect(() => {
        setValue(
            "list_category",
            listCategories.filter((l) => l.checked).map(({ id }) => id)
        );
    }, [listCategories, setValue]);

    useEffect(() => {
        const fetchTags = async () => {
            setLoading(true);
            try {
                const tags = await getTags();

                if (playoff) {
                    const lis = tags.results.map((tag) => {
                        const isChecked = playoff.list_category.some(
                            (lis) => lis.id === tag.id
                        );
                        return {
                            ...tag,
                            checked: isChecked,
                        };
                    });
                    setListCategories(lis);
                } else {
                    setListCategories(tags.results);
                }
            } catch (error) {
                console.error("Error fetching tags:", error);
            } finally {
                // setLoading(false);
            }
        };

        fetchTags();
    }, [playoff, setLoading]);

    useEffect(() => {
        const user = getCurrentUser();
        setUser(user);
    }, []);

    const handleOnChange = (event) => {
        const newImage = event.target?.files?.[0];
        console.log(newImage);
        if (newImage) {
            // console.log(newImage);
            setFilename(newImage.name);
            setImage(URL.createObjectURL(newImage));
            setOpen(true);
        }
    };

    const handleConfirmGroup = (group, flag) => {
        setDeleteGroup(group);
        setGroupOpenDialog(flag);
    };

    const onSubmit = async (data) => {
        setLoading(true);
        console.log(data);
        data.allowed_to_cart = allowedToCart;
        data.active = !data.active;
        // if (!prize) {
        // 	notify("Add Giveway for the playoff");
        // 	setAddPrize(true);
        // 	return;
        // }

        data.play_off_start_date_time = data.play_off_start_date_time.format();
        data.voting_start_date_time = data.play_off_end_date_time.format();
        data.voting_end_date_time = data.play_off_end_date_time
            .clone()
            .add(1, "days")
            .format();
        data.play_off_end_date_time = data.play_off_end_date_time.format();
        console.log(data);
        if (isGrouped && !groups.length) {
            showToast("Add atleast one Group", "error");
            setGroupOpen(true);
            setLoading(false);
            return;
        }

        if (!isGrouped && !products.length) {
            showToast("Add atleast one Product", "error");
            setGroupOpen(true);
            setLoading(false);
            return;
        }

        if (prize) {data["prize"] = prize.id;}
        data["grouped_list"] = isGrouped;

        // if (!data.products) {
        // 	setAddProduct(true);
        // 	notify();
        // 	return;
        // }

        // let formData = new FormData();
        const formData = new FormData();
        let pproducts;
        let pgroups;

        for (const i in data) {
            if (i === "list_category") {
                if (data[i].length) {
                    console.log(data[i]);
                    formData.append(i, data[i]);
                }
            } else if (i === "file") {
                console.log(i, data[i]);
                if (data[i].length) {
                    const blob = await fetch(image).then((r) => r.blob());
                    formData.append("file", blob, filename);
                }
            } else if (i === "brand") {
                formData.append(i, data[i]);
            } else if (i === "aesthetic" && data[i]) {
                formData.append(i, data[i].id);
            } else if (i === "buckets") {
                formData.append(i, data[i]);
            }
            else {formData.append(i, data[i]);}
        }

        // if (!data.owner) {
        // 	data.owner = 2;
        // }
        // for (let i in data) {
        // 	if (i === "image") {
        // 		formData.append(i, data[i][0]);
        // 	} else formData.append(i, data[i]);
        // }
        if (isGrouped) {
            data["groups"] = groups.map((g) => g.id);
            console.log(groups);
            pgroups = groups.map((p) => parseInt(p.id));
            console.log(pgroups);
            formData.append("groups", pgroups);
        } else {
            data["products"] = products.map((g) => g.id);
            pproducts = products.map((p) => parseInt(p.id));
            formData.append("products", pproducts);
        }

        formData["list_category"] = [data["list_category"]];
        const res = await (playoff
            ? UpdatePlayoff(formData, playoff.id)
            : Create(formData));
        setLoading(false);
        console.log("====================================");
        console.log(res);
        console.log("====================================");

        if (res.success) {
            if (allowedToCart) {
                if (user?.user_type === 4) {
                    navigate("/upload-playoff/cart/playoffs");
                } else {
                    navigate("/w86zjruk6q/cart/playoffs");
                }
            } else {
                if (user?.user_type === 4) {
                    navigate("/upload-playoff/playoff");
                } else {
                    navigate("/w86zjruk6q/playoff");
                }
            }

            // 	let newSellers = await getAllSeller();
            // 	setRows(newSellers.results);
            // 	setEditOpen(false);
        }
    };

    return (
        <Grid container justifyContent="center" spacing={2}>
            {loading && <FullHeightLoader />}
            <Grid item xs={12} md={8}>
                <Box sx={{ px: 5 }}>
                    <FormWrapper
                        onSubmit={handleSubmit(onSubmit)}
                        sx={{ p: 5 }}
                    >
                        <Box my={3}>
                            {console.log("333333", watch("buckets"))}
                            <Controller
                                name="title"
                                control={control}
                                rules={{ required: "Enter Playoff title" }}
                                render={({ field }) => (
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        {...field}
                                        fullWidth
                                        // name="title"
                                        label="Enter playoff title"
                                        variant="outlined"
                                        error={Boolean(errors.title)}
                                        helperText={errors.title?.message}
                                    />
                                )}
                            />
                        </Box>

                        <Box my={3}>
                            <TextField
                                fullWidth
                                name="description"
                                multiline
                                InputLabelProps={{ shrink: true }}
                                minRows={3}
                                // style={{ width: "100%" }}
                                label="Enter description"
                                variant="outlined"
                                {...register("description", {
                                    required: "Enter description",
                                })}
                                error={Boolean(errors.description)}
                                helperText={errors.description?.message}
                            />
                        </Box>
                        <Box my={3}>
                            <TextField
                                fullWidth
                                name="alias"
                                label="Enter alias"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                error={Boolean(errors.alias)}
                                helperText={errors.alias?.message}
                                {...register("alias", {
                                    required: "Enter alias",
                                })}
                            />
                        </Box>
                        <Box my={3}>
                            <TextField
                                fullWidth
                                multiline
                                minRows={1}
                                label="Small Description"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                error={Boolean(errors.title)}
                                helperText={errors.title?.message}
                                {...register("small_description", {
                                    // required: "Enter List name",
                                })}
                            />
                        </Box>

                        <Box my={3}>
                            <FormControl
                                required
                                error={Boolean(errors.list_category)}
                                // component="outlined"
                                // sx={{ m: 3 }}
                                variant="outlined"
                            >
                                <FormLabel>List Category</FormLabel>
                                <FormGroup row>
                                    {listCategories.map((inputlist, i) => {
                                        return (
                                            <FormControlLabel
                                                key={`listt-${i}`}
                                                control={
                                                    <Checkbox
                                                        {...register(
                                                            "list_category"
                                                        )}
                                                        value={inputlist.id}
                                                        checked={
                                                            !!inputlist.checked
                                                        }
                                                        onChange={(e) => {
                                                            setListCategories(
                                                                listCategories.map(
                                                                    (l) =>
                                                                        l.id ===
                                                                            inputlist.id
                                                                            ? {
                                                                                ...l,
                                                                                checked:
                                                                                    !l.checked,
                                                                            }
                                                                            : l
                                                                )
                                                            );
                                                        }}
                                                        name="list_category"
                                                    />
                                                }
                                                label={inputlist.name}
                                            />
                                        );
                                    })}
                                </FormGroup>
                                <FormHelperText>
                                    {errors.list_category?.message}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                        <Box my={3}>
                            <Grid container spacing={2}>
                                <Grid item md={4}>
                                    <ControlledAutocomplete
                                        name={"brand"}
                                        label={"Brand (optional)"}
                                        fetchOptions={getAllBrand}
                                        form={form}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        InputProps={{
                                            inputProps: { min: 1 },
                                        }}
                                        id="outlined-basic"
                                        label={"Max Entries Allowed"}
                                        variant="outlined"
                                        {...register("max_entries_allowed", {
                                            // required:
                                            // 	"Enter No of Entries Allowed",
                                        })}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        {...register("price_limit", {
                                            // required:
                                            // 	"Enter Price Limit",
                                        })}
                                        type="number"
                                        InputProps={{
                                            inputProps: { min: 0 },
                                        }}
                                        fullWidth
                                        id="outlined-basic"
                                        label={"Price Limit"}
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Box my={3}>
                            <Grid container spacing={2}>
                                <Grid item md={6}>
                                    <LocalizationProvider
                                        dateAdapter={AdapterMoment}
                                    >
                                        <Controller
                                            control={control}
                                            name="play_off_start_date_time"
                                            defaultValue={null}
                                            rules={{
                                                required:
                                                    "please select the start date",
                                                // 	validate: {
                                                // 		// min: (date) => {
                                                // 		// 	return (
                                                // 		// 		date.isAfter(
                                                // 		// 			dayjs()
                                                // 		// 		) ||
                                                // 		// 		"Please, enter a future date"
                                                // 		// 	);
                                                // 		// },
                                                // 	},
                                            }}
                                            render={({
                                                field: {
                                                    ref,
                                                    onBlur,
                                                    onChange,
                                                    name,
                                                    ...field
                                                },
                                                fieldState,
                                            }) => (
                                                <DateTimePicker
                                                    {...field}
                                                    onChange={(newValue) => {
                                                        onChange(newValue);
                                                        setValue(
                                                            "play_off_end_date_time",
                                                            newValue
                                                                .clone()
                                                                .add(1, "days")
                                                        );
                                                    }}
                                                    inputRef={ref}
                                                    label="Start date & time"
                                                    // minDateTime={dayjs()}
                                                    renderInput={(
                                                        inputProps
                                                    ) => (
                                                        <TextField
                                                            fullWidth
                                                            {...inputProps}
                                                            onBlur={onBlur}
                                                            name={name}
                                                            error={
                                                                !!fieldState.error
                                                            }
                                                            helperText={
                                                                fieldState.error
                                                                    ?.message
                                                            }
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item md={6}>
                                    <LocalizationProvider
                                        dateAdapter={AdapterMoment}
                                    >
                                        <Controller
                                            control={control}
                                            name="play_off_end_date_time"
                                            defaultValue={null}
                                            rules={{
                                                required:
                                                    "please select the end date",
                                                validate: {
                                                    min: (date) => {
                                                        return (
                                                            watch(
                                                                "play_off_start_date_time"
                                                            ) ||
                                                            "End date should be greatern then start date"
                                                        );
                                                    },
                                                },
                                            }}
                                            render={({
                                                field: {
                                                    ref,
                                                    onBlur,
                                                    onChange,
                                                    name,
                                                    ...field
                                                },
                                                fieldState,
                                            }) => (
                                                <DateTimePicker
                                                    {...field}
                                                    minDateTime={
                                                        watch(
                                                            "play_off_start_date_time"
                                                        )
                                                            ? watch(
                                                                "play_off_start_date_time"
                                                            )
                                                            : moment()
                                                    }
                                                    onChange={(newValue) => {
                                                        // setEndDate(newValue);
                                                        onChange(newValue);
                                                    }}
                                                    inputRef={ref}
                                                    label="End date & time"
                                                    renderInput={(
                                                        inputProps
                                                    ) => (
                                                        <TextField
                                                            fullWidth
                                                            {...inputProps}
                                                            onBlur={onBlur}
                                                            name={name}
                                                            error={
                                                                !!fieldState.error
                                                            }
                                                            helperText={
                                                                fieldState.error
                                                                    ?.message
                                                            }
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box my={3}>
                            <Grid container spacing={2}>
                                <Grid item md={8}>

                                    <Box
                                        mb={3}
                                        display="flex"
                                        justifyContent="space-between"
                                    >
                                        <Typography variant="h6" gutterBottom>
                                            Give Away
                                        </Typography>

                                        <Button
                                            type="button"
                                            onClick={handleAddPrize}
                                            color="primary"
                                            variant="contained"
                                        >
                                            {prize ? "Edit" : "Add"} Give Away
                                        </Button>
                                    </Box>

                                    {prize && (
                                        <Card sx={{ display: "flex" }}>
                                            <CardMedia
                                                sx={{
                                                    objectFit: "cover",
                                                    width: "150px",
                                                }}
                                                component="img"
                                                // height="240"
                                                image={prize.image}
                                                alt="green iguana"
                                            />
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: 1,
                                                }}
                                            >
                                                <CardContent>
                                                    <Typography
                                                        gutterBottom
                                                        variant="h6"
                                                        component="div"
                                                    >
                                                        {prize.title}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                    >
                                                        {prize.description}
                                                    </Typography>
                                                </CardContent>
                                            </Box>
                                        </Card>
                                    )}
                                </Grid>
                                <Grid item xs={4}>
                                    {image && (
                                        <>
                                            <Box
                                                sx={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                <FormControl
                                                    error={Boolean(errors.file)}
                                                >
                                                    {playoff.image.file && (
                                                        <Avatar
                                                            variant="square"
                                                            src={
                                                                playoff.image
                                                                    .file
                                                            }
                                                            sx={{
                                                                width: 150,
                                                                height: 200,
                                                                objectFit:
                                                                    "fill",
                                                                marginBottom: 2,
                                                                marginX: "auto",
                                                            }}
                                                        />
                                                    )}
                                                    <Button
                                                        variant="contained"
                                                        component="label"
                                                        onChange={
                                                            handleOnChange
                                                        }
                                                    >
                                                        {!playoff.image.file
                                                            ? "Upload "
                                                            : "Change "}
                                                        image
                                                        <input
                                                            hidden
                                                            accept="image/*"
                                                            id="file-upload"
                                                            type="file"
                                                            {...register(
                                                                "file",
                                                                {
                                                                    // required: image == null,
                                                                }
                                                            )}
                                                            error={errors.file}
                                                        />
                                                    </Button>
                                                </FormControl>
                                            </Box>
                                            <ImageCropper
                                                image={image}
                                                setImage={setImage}
                                                open={open}
                                                setOpen={setOpen}
                                                aspect={3 / 4}
                                            />
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                        >
                            <Typography variant="h6">
                                Playoff Buckets
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={handleOpenBucketDialog}
                            >
                                Add to Buckets
                            </Button>
                        </Stack>
                        <Box display="flex" gap={1} flexWrap="wrap" mb={3}>
                            {selectedBuckets.map((bucket) => (
                                <Chip
                                    key={bucket.id}
                                    label={bucket.name}
                                    onDelete={() => {
                                        setSelectedBuckets((prev) =>
                                            prev.filter((b) => b.id !== bucket.id)
                                        );

                                        setValue(
                                            "buckets",
                                            watch("buckets").filter((id) => id !== bucket.id)
                                        );
                                    }}
                                />
                            ))}
                        </Box>

                        <Box my={3}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isGrouped}
                                        onChange={(e) => {
                                            setValue("price_limit", "");
                                            setValue("qty_limit", "");
                                            if (e.target.checked) {
                                                unregister("qty_limit");
                                            } else {
                                                // register("price_limit");
                                                register("qty_limit");
                                            }
                                            setIsGrouped(e.target.checked);
                                        }}
                                    />
                                }
                                label="Grouped List"
                            />
                        </Box>
                        <Box my={3}>
                            {isGrouped ? (
                                <>
                                    <Box
                                        mb={3}
                                        display="flex"
                                        justifyContent="space-between"
                                    >
                                        <Typography variant="h6" gutterBottom>
                                            Groups
                                        </Typography>
                                        <Button
                                            type="button"
                                            onClick={handleAddGroup}
                                            color="primary"
                                            variant="contained"
                                        >
                                            {"Add Groups"}
                                        </Button>
                                    </Box>
                                    {groups.length > 0 && (
                                        <Grid container spacing={2}>
                                            {groups.map((group, i) => {
                                                group.expand = false;
                                                return (
                                                    <Group
                                                        group={group}
                                                        key={`group-${i}`}
                                                        handleConfirmGroup={
                                                            handleConfirmGroup
                                                        }
                                                    />
                                                );
                                            })}
                                        </Grid>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Box
                                        mb={3}
                                        display="flex"
                                        justifyContent="space-between"
                                    >
                                        <Typography variant="h6" gutterBottom>
                                            Products
                                        </Typography>
                                        <Button
                                            type="button"
                                            // onClick={handleAddProduct}
                                            color="primary"
                                            variant="contained"
                                        >
                                            {"Add Products"}
                                        </Button>
                                    </Box>
                                    {products && (
                                        <Box my={3}>
                                            <Grid container spacing={2}>
                                                {products.map((item, i) => (
                                                    <Grid key={item.id ?? i} item xs={12} md={3}>
                                                        <Card
                                                            sx={{
                                                                height: "100%",
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between",
                                                                flexDirection:
                                                                    "column",
                                                            }}
                                                        >
                                                            <CardMedia
                                                                component="img"
                                                                // height="194"
                                                                image={
                                                                    item.image
                                                                        .file
                                                                }
                                                                alt="Paella dish"
                                                            />
                                                            <CardContent>
                                                                <Typography
                                                                    variant="body2"
                                                                    color="text.secondary"
                                                                >
                                                                    {item.name}
                                                                </Typography>
                                                            </CardContent>
                                                            <CardActions
                                                                disableSpacing
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "end",
                                                                    justifyContent:
                                                                        "flex-end",
                                                                }}
                                                            >
                                                                <IconButton
                                                                    aria-label="edit"
                                                                    onClick={() => { }}
                                                                >
                                                                    <Edit />
                                                                </IconButton>
                                                                <IconButton
                                                                    aria-label="delete product"
                                                                    onClick={() => {
                                                                        // handleOpen(
                                                                        // 	item
                                                                        // );
                                                                        // setProducts(new_products)
                                                                    }}
                                                                >
                                                                    <Delete color="secondary" />
                                                                </IconButton>
                                                            </CardActions>
                                                        </Card>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Box>
                                    )}
                                </>
                            )}
                        </Box>

                        <Box my={3}>
                            <Grid container spacing={2}>
                                {!isGrouped && (
                                    <Grid item md={4}>
                                        <TextField
                                            fullWidth
                                            id="outlined-basic"
                                            label={"Qty Limit"}
                                            type="number"
                                            InputProps={{
                                                inputProps: { min: 0 },
                                            }}
                                            {...register("qty_limit", {
                                                required: "Enter Qty Limit",
                                            })}
                                            variant="outlined"
                                        />
                                    </Grid>
                                )}
                                <Grid item md={4}>

                                    <Box
                                        sx={{
                                            paddingX: 2,
                                            paddingY: 0.75,
                                            border: "1px solid rgba(0, 0, 0, 0.23)",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        <Stack
                                            direction={"row"}
                                            justifyContent="space-between"
                                            alignItems={"center"}
                                        >

                                            <FormLabel>Save as Draft</FormLabel>
                                            <Controller
                                                name="active"
                                                control={control}
                                                defaultValue={false}
                                                render={({ field }) => (
                                                    <Switch
                                                        {...field}
                                                        checked={field.value}
                                                        onChange={(e) =>
                                                            field.onChange(
                                                                e.target.checked
                                                            )
                                                        }
                                                    // disabled
                                                    // sx={{ pointerEvents: "none" }}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Box>

                                </Grid>
                                <Grid item md={4}>
                                    <Box
                                        sx={{
                                            paddingX: 2,
                                            paddingY: 0.75,
                                            border: "1px solid rgba(0, 0, 0, 0.23)",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        <Stack
                                            direction={"row"}
                                            justifyContent="space-between"
                                            alignItems={"center"}
                                        >
                                            <FormLabel>For PlayOff</FormLabel>
                                            <Controller
                                                name="is_playoff"
                                                control={control}
                                                defaultValue={false}
                                                render={({ field }) => (
                                                    <Switch
                                                        {...field}
                                                        checked={field.value}
                                                        onChange={(e) =>
                                                            field.onChange(
                                                                e.target.checked
                                                            )
                                                        }
                                                    // disabled
                                                    // sx={{ pointerEvents: "none" }}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Box>
                                </Grid>
                                <Grid item md={4}>
                                    <Controller
                                        name="aesthetic"
                                        control={control}
                                        defaultValue={null}
                                        render={({ field }) => (
                                            <AestheticInput field={field} />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        <Box my={3}></Box>

                        <Box mb={3}>
                            {/* added universal cart switch */}

                            <Grid item md={4}>
                                <Box
                                    sx={{
                                        px: 2,
                                        py: 0.75,
                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                        borderRadius: "4px",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <Stack
                                        direction={"row"}
                                        justifyContent="space-between"
                                        alignItems={"center"}
                                    >
                                        <FormLabel>Universal Cart</FormLabel>

                                        <Switch
                                            name="allowed_to_cart"
                                            checked={allowedToCart}
                                            onChange={(e) =>
                                                setAllowedToCart(
                                                    e.target.checked
                                                )
                                            }
                                        />
                                    </Stack>
                                </Box>
                            </Grid>

                            <Button
                                type="submit"
                                fullWidth
                                // onClick={handleSave}
                                color="primary"
                                variant="contained"
                            >
                                {"Save"}
                            </Button>
                        </Box>
                    </FormWrapper>
                </Box>

                {/* <Drawer
						anchor="right"
						open={addProduct}
						onClose={() => setAddProduct(false)}
					>
						<AddProductDrawer
							fromGroup={false}
							setEditOpen={setAddProduct}
							products={products}
							setProducts={setProducts}
						/>
					</Drawer> */}
            </Grid>
            {/* <Dialog
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				open={open}
				onClose={handleClose}
				closeAfterTransition
				// BackdropComponent={Backdrop}
				// BackdropProps={{
				// 	timeout: 500,
				// }}
			>
				<DialogTitle id="alert-dialog-title">
					{"Are you sure?"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Do you want to remove product
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>No</Button>
					<Button
						onClick={() => {
							let new_products = products.filter((product) => {
								return product !== deletingProduct;
							});
							setDeletingProduct({});
							setProducts(new_products);
							handleClose();
						}}
						autoFocus
						color="secondary"
					>
						Yes
					</Button>
				</DialogActions>
			</Dialog>*/}

            <Dialog
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={groupOpen}
                onClose={() => {
                    handleConfirmGroup(null, false);
                }}
                closeAfterTransition
            // BackdropComponent={Backdrop}
            // BackdropProps={{
            // 	timeout: 500,
            // }}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Are you sure?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Do you want to remove Group
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            handleConfirmGroup(null, false);
                        }}
                    >
                        No
                    </Button>
                    <Button
                        onClick={() => {
                            setGroups((prevGroups) =>
                                prevGroups.filter(
                                    (g) => g.id !== deleteGroup.id
                                )
                            );
                            handleConfirmGroup(null, false);
                        }}
                        autoFocus
                        color="secondary"
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openBucketDialog}
                onClose={handleCloseBucketDialog}
                keepMounted
                PaperProps={{
                    sx: {
                        width: 700,
                        p: 3,
                    },
                }}
                maxWidth="md"
            >
                <DialogTitle>Add to Buckets</DialogTitle>

                <DialogContent>
                    <Autocomplete
                        multiple
                        options={buckets}
                        value={selectedBuckets}
                        onChange={(_, value) => setSelectedBuckets(value)}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search Buckets"
                            />
                        )}
                    />
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={handleCloseBucketDialog}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => {
                            setValue(
                                "buckets",
                                selectedBuckets.map((bucket) => bucket.id)
                            );

                            handleCloseBucketDialog();
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
};
